import { twMerge } from 'tailwind-merge';

interface Props {
    className?: string;
    children: React.ReactNode;
}

const SectionTitle = ({ className, children }: Props) => (
    <div className={twMerge('py-2 text-xl leading-8 font-bold', className)}>
        {children}
    </div>
);

export default SectionTitle;
